/**
 * The main api service
 */
import http from "@util/http";
import { common, hr, workflow } from "./req";

/**
 * 登陆
 */
export async function queryLogin(user) {
  return http.post(common.LOGIN, user);
}

export async function queryExample() {
  return [0, 1, 2];
}

export async function queryWageDetailPersonal(params) {
  return http.get(hr.WAGE_DETAIL_PERSONAL, params);
}

export async function queryPayRoll(params) {
  return http.get(workflow.GET_PAYROLL, params);
}



// WEBPACK FOOTER //
// ./src/api/index.js